module.exports = __webpack_public_path__ + "static/media/anghami.58b018de.svg";